/**
 * @description 百度富文本打包配置 发版时需要根据环境修改
 * @author qi
 * @date 2023-03-07
 */
const bdPackConfig = {
  // editor输入内容:
  // oadev
  // baiduEditorUrl: 'http://oadev.5dip.com/ueditor/oaadmin/utf8-jsp/',

  // oaadmin
  // baiduEditorUrl: 'http://oaadmin.5dip.com/ueditor/oaadmin/utf8-jsp/',

  // 彩智 正式
  baiduEditorUrl: 'https://oa.bjmzgyzgs.com/ueditor/oaadmin/utf8-jsp/',

  // upload:
  // oadev
  // baiduUploadUrl: 'http://oadev.5dip.com/admin/ueditor/upload',

  // oaadmin 
  // baiduUploadUrl: 'http://oaadmin.5dip.com/admin/ueditor/upload',

  // 彩智 正式
  baiduUploadUrl: 'https://oa.bjmzgyzgs.com/admin/ueditor/upload',

}

export default bdPackConfig


// WEBPACK FOOTER //
// ./src/utils/bdPackConfig.js